import React from 'react'; 
import MovieTimesPeriodeDaysItemAttributes from './MovieTimesPeriodeDaysItemAttributes';
import getBackgroundcolor from '../func/getBackgroundcolor';
import getShowtime from '../func/getShowtime';
import getCaptions from '../func/getCaptions';

const MovieTimesPeriodeDaysItems = ({performances, hideTheatres, hasFlyerCaptions, chosen_font, attributesColors, captionAttributes, accentColorDark, accentColor, cinemaData, themeColors, iconsColor, reducedVersion}) => {
    return performances.map((performance, index) => {
        let style 
        let styleFirst
        let styleSecond
        let styleThird
        let styleFourth
        let styleFifth
        let styleSixth
        let borderStyle
        let compesoUrl
        const { timeUtc, theatreName, deeplinkURL, attributes } = performance
        const shopData = cinemaData && cinemaData.scope ? cinemaData.scope.cinemaDataProvider : null
        const attributeCaptions = getCaptions(attributes, captionAttributes)

        if(hasFlyerCaptions) {
            style = { 
                backgroundColor: getBackgroundcolor(accentColorDark, null, themeColors, true)
            }

            borderStyle = {
                borderColor: getBackgroundcolor(accentColorDark, null, themeColors, true)
            }
        }

        if(shopData && (shopData.type === 'compeso' || shopData.type === 'kinoheld')) {
            compesoUrl = cinemaData.website + 'vorstellung/?performance_id=' + performance.id
        }

        if(attributes && !hasFlyerCaptions) {
            attributes.map((attribute) => {
                const id = String(attribute.id)                

                if(id === '1087' || id === '2d' || id === 'digital') {
                    style = {
                        backgroundColor: getBackgroundcolor(accentColorDark, attribute, themeColors)
                    }
                } else if(id === '1088' || id === '3d') {
                    style = { 
                        backgroundColor: getBackgroundcolor(accentColorDark, attribute, themeColors),
                        border: 'none'
                    }
                } else if(id === '1522') {
                    styleFirst = { borderColor: 'transparent transparent transparent ' + accentColorDark }
                } else if(id === '1666') {
                    styleSecond = { borderColor: 'transparent ' + accentColorDark + ' transparent transparent' }
                } else {
                    const colorToUseItem = _.find(attributesColors, attr => {
                        return attr.id === id
                    })

                    const colorToUse = colorToUseItem ? colorToUseItem.colorToUse : 1

                     if(colorToUse === 1) {
                        styleThird = {
                            borderColor: 'transparent transparent ' +  accentColorDark + ' transparent'
                        }
                    } else if(colorToUse === 2) {
                        styleFourth = {
                            borderColor: 'transparent transparent transparent' +  accentColor,
                            filter: "sepia(1)"
                        }
                    }  else if(colorToUse === 3) {
                        styleFifth = {
                            borderColor: 'transparent ' +  accentColor + ' transparent transparent',
                            filter: "sepia(1) invert(1) brightness(1.5)"
                        }
                    } else {
                        styleSixth = {
                            borderColor: '' +  accentColorDark + ' transparent transparent transparent',
                            filter: "invert(1)"
                        }
                    }
                }
            })
        }
        
        return hasFlyerCaptions ? (
            <a key={index} style={borderStyle} href={compesoUrl ? compesoUrl : deeplinkURL} target="_blank" className={"show-wrapper cursor-pointer"}>
                <span className={`${chosen_font}-text-xsmall-light showtime`}>{getShowtime(timeUtc)}</span>
                <span className={`${chosen_font}-text-xsmall-light captions`} style={style}>{attributeCaptions.map((cap, index) => {
                    return <span className='caption' key={index}>{cap}</span>
                })}</span>
            </a>
        ) : reducedVersion ? (
            <a style={style} key={index} href={compesoUrl ? compesoUrl : deeplinkURL} target="_blank" className={"show-wrapper cursor-pointer"}>
                <span className={`${chosen_font}-text-xsmall-light showtime`}>{getShowtime(timeUtc)}</span>
                {styleFirst && <div style={styleFirst} className="atmos-styling attribute-border"></div>}
                {styleSecond && <div style={styleSecond} className="dbox-styling attribute-border"></div>}
                {styleThird && <div style={styleThird} className="others-styling item-1 attribute-border"></div>}
                {styleFourth && <div style={styleFourth} className="others-styling item-2 attribute-border"></div>}
                {styleFifth && <div style={styleFifth} className="others-styling item-3 attribute-border"></div>}
                {styleSixth && <div style={styleSixth} className="others-styling item-4 attribute-border"></div>}
            </a>
        ) : (
            <a key={index} href={compesoUrl ? compesoUrl : deeplinkURL} target="_blank" className={"show-wrapper cursor-pointer"}>
                <span className={`${chosen_font}-text-bold-grey showtime`}>{getShowtime(timeUtc)}</span>
                <MovieTimesPeriodeDaysItemAttributes accentColorDark={accentColorDark} attributes={attributes} hideTheatres={hideTheatres} theatreName={theatreName} iconsColor={iconsColor}/>
            </a>
        )
    })
}

export default MovieTimesPeriodeDaysItems